import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import PiAfEventReaderTableDto from '../dto/PiAfEventReaderTableDto';

class PiAfEventReaderTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'piAfEventReaderTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, { session, firstResult, maxResults })
				.then(response => resolve(new GenericTableDto().setup(response.data, PiAfEventReaderTableDto)))
				.catch(reject);
		});
	}
}

export default new PiAfEventReaderTableService();
